/**
 * Agora RTC 模块
 * 负责初始化 Agora RTC 客户端
 */

import agoraManager from '@/managers/AgoraRTCManager'

/**
 * 初始化 Agora RTC 客户端
 */
export function initAgora() {
  agoraManager.initClient()
}
